import { ListRendererColumnConfig } from '../models/list-renderer-config.model';

export interface ListRendererWidget {
  item: any;
  index: number;
  field: string;
  context: Record<string, any>;
  column?: ListRendererColumnConfig;
}
